<template>
    <div v-if="uploadProgress" id="upload-progress" class="upload-progress">
        <label>{{uploadProgress.loaded | units}} / {{uploadProgress.total | units}} @ {{Math.round(uploadProgress.speed)}} kbps</label>


    <div class="progress-bar" v-bind:style="{ width: uploadProgress.progress + '%'}"></div>
    </div>

</template>

<script>

    export default {
        props: [],
        template: '#upload-progress',
        name: 'upload-progress',
        data() {
            return {

            };
        },

        computed: {
            uploadProgress() {
                return this.$store.getters.uploadProgress;
            }
        },

    }

</script>

<style lang="scss" scoped>
.upload-progress {
    background:#303030;
    width:100%;
    position:fixed;
    top:0;
    left:0;
    z-index:99999999999999;
    height:4rem;
}
label {
    width:100%;
    height:100%;
    position: absolute;
    left:0;
    text-align:center;
    z-index:99999;
    font-size: 2rem;
    line-height: 4rem;
    color:#fff;
    letter-spacing: 2px;
    font-weight:400;
    text-transform: uppercase;
}
.progress-bar {
    background:#42b983;
    padding:1rem;
}
</style>




// WEBPACK FOOTER //
// UploadProgress.vue?ac034056